import React from 'react';
import { delay } from 'helpers';
import MediaQuery from 'react-responsive';
import * as actions from 'actions';
import { connect } from 'react-redux';
import Reels from './Reels';
import MobileReels from './MobileReels';

// const ReelsWrapper = props => ;
class ReelsWrapper extends React.Component {
  state = { loadedReels: 0 };

  componentDidMount() {
    delay(3000).then(this.props.setPageReady);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !this.props.pageReady &&
      this.state.loadedReels ===
        this.props.reels.filter(item => item.type === 'reel').length
    ) {
      this.props.setPageReady();
    }
  }

  loadCb = () => {
    this.setState(prevState => ({ loadedReels: prevState.loadedReels + 1 }));
  };

  render() {
    return (
      <React.Fragment>
        <MediaQuery maxWidth={1024}>
          <MobileReels loadCb={this.loadCb} {...this.props} />
        </MediaQuery>
        <MediaQuery minWidth={1025}>
          <Reels loadCb={this.loadCb} {...this.props} />
        </MediaQuery>
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  reels: state.data.reels,
  pageReady: state.pageReady,
});

const mapDispatch = dispatch => ({
  setPageReady: () => dispatch(actions.setPageReady()),
});

export default connect(mapState, mapDispatch)(ReelsWrapper);



// WEBPACK FOOTER //
// ./src/components/screens/Reels/ReelsWrapper.js